<template>
  <KCard h-icon="ios-flag" htitle="Top Countries">
    <div slot="content" >
      <div v-for="(item, idx) in counts" :key="idx" style="padding-bottom:10px;">
        <Icon type="ios-flag" size="20"/> <b>{{ item.country }}</b> ({{ item.country_count }} views)
      </div>
    </div>
  </KCard>
</template>

<script>
import KCard from '@/components/ui/Card'

export default {
  props: {
    counts: {
      type: Array,
      default: () => []
    }
  },

  components: {
    KCard
  }
}
</script>
